<template>
    <div>
        <div>
            <!-- SELECT CURRENCY -->
            <el-form-item
                :label="$t.__('dashboard.forms.TurnoverSettingForm.select_card_currency')"
                prop="currency"
            >
                <currency-input v-model="form.currency" @input="updateCurrency"></currency-input>
            </el-form-item>
            <!-- RADIO TAX -->
            <el-form-item :label="$t.__('common.actions.select_tax_display')" prop="taxMode">
                <el-radio-group v-model="form.taxMode">
                    <el-radio label="exc" class="mt-2">{{ $l10n.__('HT') }}</el-radio>
                    <br />
                    <el-radio label="inc" class="mt-3">{{ $l10n.__('TTC') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- SUBMIT -->
            <div class="aright mt-5">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close"
                />
                <CompassButton
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    @click="submitForm"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import CurrencyInput from 'vcomponents/inputs/CurrencyInput.vue';

export default {
    mixins: [SettingsFormMixin],
    data() {
        return {
            turnoverRules: {
                currency: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez sélectionner une devise'),
                        trigger: 'submit',
                    },
                ],
                taxMode: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'submit',
                    },
                ],
            },
        };
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateCurrency(currency) {
            this.form.currency = currency.name;
        },
    },
    mounted() {
        this.$emit('set-rules', this.turnoverRules);
    },
    components: {
        CurrencyInput,
    },
};
</script>
